import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ARFiber from '@/ui/components/client/ARFiber/ARFiber';
import ClientRecipeDetail from "@/ui/pages/client/ClientRecipeDetail/ClientRecipeDetail";
import Home from "@/ui/pages/client/ClientHome/ClientHome";
import ClientMenu from "@/ui/pages/client/ClientMenu/ClientMenu";
import ClientCommentList from "@/ui/pages/client/ClientCommentList/ClientCommentList";
import ProtectedRoute from './ProtectedRoute';

// ADMIN
import AdminHomePage from '@/ui/pages/admin/AdminHome/AdminHome';
import ClientHomePage from '@/ui/pages/client/ClientHome/ClientHome';
import AdminProductEdit from "@pages/admin/AdminProductEdit/AdminProductEdit";
import AdminAddRecipePage from "@/ui/pages/admin/AdminAddRecipeBook/AdminAddRecipeBook";
import AdminRecipeDetailPage from "@/ui/pages/admin/AdminProductDetail/AdminProductDetail";
import AdminAddRecipeBookPage from "@/ui/pages/admin/AdminAddRecipe/AdminAddRecipe";
import AdminLoginPage from '@/ui/pages/admin/AdminLogin/AdminLogin';

// TEST
import NewRecipeTest from '@/test/pages/NewRecipeTest/NewRecipeTest'
import AddRecipePage from "@/ui/pages/admin/AdminAddRecipe/AdminAddRecipe";

import { ROUTES } from '@/config/routes';

const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* Public Client Routes */}
                <Route path={ROUTES.CLIENT_HOME} element={<ClientHomePage />} />
                <Route path={ROUTES.CLIENT_MENU} element={<ClientMenu />} />
                <Route path="/test" element={<Home />} />
                <Route path={`${ROUTES.CLIENT_DETAIL}/:productId`} element={<ClientRecipeDetail />} />
                <Route path={ROUTES.CLIENT_DETAIL} element={<ClientRecipeDetail />} />

                {/* Admin Login Route (Must be public) */}
                <Route path="/admin/login" element={<AdminLoginPage />} />

                {/* ================= PROTECTED ADMIN ROUTES ================= */}
                <Route element={<ProtectedRoute />}>
                    <Route path={ROUTES.ADMIN_HOME} element={<AdminHomePage />} />
                    <Route path={ROUTES.ADMIN_RECIPE_BOOK} element={<AdminAddRecipeBookPage />} />
                    <Route path={ROUTES.ADMIN_ADD_RECIPE} element={<AdminAddRecipePage />} />
                    <Route path={ROUTES.ADMIN_ADD_PRODUCT} element={<AdminProductEdit />} />
                    <Route path={ROUTES.ADMIN_RECIPE_DETAIL} element={<AdminRecipeDetailPage />} />
                    <Route path={`${ROUTES.ADMIN_PRODUCT_DETAIL}/:productId`} element={<AdminRecipeDetailPage />} />
                    <Route path={ROUTES.ADMIN_PRODUCT_DETAIL} element={<AdminRecipeDetailPage />} />
                    <Route path={ROUTES.ADMIN_PRODUCT_EDIT} element={<AdminProductEdit />} />
                </Route>
                {/* ============================================================= */}

                {/* Global Redirects */}
                <Route path="/" element={<Navigate to={ROUTES.CLIENT_HOME} replace />} />
                <Route path="*" element={<div>404 - Not Found</div>} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter;
